import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RecruitPageConfigModel } from 'services/models/recruitment/recruitment-page-config.model';

@Component({
  selector: 'app-configurable-cover',
  templateUrl: './configurable-cover.component.html',
  styleUrls: ['./configurable-cover.component.scss']
})
export class ConfigurableCoverComponent implements OnInit, OnChanges {
  @Input() config: RecruitPageConfigModel | null = null;
  @Input() fallbackImage: string = 'assets/images/pages/bg-workwithus.png';
  @Input() cssClass: string = 'hero-section';
  @Input() showGradient: boolean = true;
  /** Below lg, use cover instead of contain (reduces letterboxing on narrow viewports). */
  @Input() responsiveHeroFit = false;

  public displayImage: string = '';
  public hasCustomCover: boolean = false;

  ngOnInit(): void {
    this.updateDisplayImage();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.updateDisplayImage();
  }

  private updateDisplayImage(): void {
    if (this.config?.coverFileUrl && this.config.coverFileUrl.trim()) {
      this.displayImage = this.config.coverFileUrl;
      this.hasCustomCover = true;
    } else {
      this.displayImage = this.fallbackImage;
      this.hasCustomCover = false;
    }
  }

  public getBackgroundStyle(): string {
    const backgroundUrl = this.buildBackgroundUrl(this.displayImage);

    if (this.showGradient && !this.hasCustomCover) {
      return `linear-gradient(135deg, rgba(28, 110, 216, 0.3) 0%, rgba(22, 88, 173, 0.3) 100%), ${backgroundUrl}`;
    }
    return backgroundUrl;
  }

  public getCustomCoverUrl(): string {
    return encodeURI((this.displayImage || '').trim());
  }

  private buildBackgroundUrl(imageUrl: string): string {
    const normalizedUrl = encodeURI((imageUrl || '').trim());
    return `url("${normalizedUrl}")`;
  }
}
